import { axiosSSO } from 'config';

export const fetchAuthUser = () => axiosSSO('/auth');

export const fetchUserById = (userId) => axiosSSO.get(`/user/${userId}`);

export const fetchAllRoles = () => axiosSSO.get('/role/all');

export const fetchAllApplications = () => axiosSSO.get('/application/all');

export const updateUserEmail = (payload) => axiosSSO.put('/user/email', payload);

export const forgotPassword = (payload) => axiosSSO.post('/user/forgot-password', payload);

export const fetchAuthProviderConfig = () => axiosSSO.get('/auth-provider-config');

export const refreshToken = () => axiosSSO.post('/auth/refresh');

const basicAuthHeader = { Authorization: 'Basic c3NvOnNzb1N0YWcxbmch' };

export const fetchUserMfa = (username) => {
    const usernameRegex = /^[a-zA-Z]/;
    if (!usernameRegex.test(username)) {
        return Promise.reject(new Error('INVALID_CREDENTIALS'));
    }
    return axiosSSO.get(`/user/${username}/mfa-code`, { headers: basicAuthHeader });
};

export const requestUserMfaCode = (username) => axiosSSO.post(`/user/${username}/mfa-code`, null, { headers: basicAuthHeader });